import React from "react";
import { Route, Redirect } from "react-router-dom";

import { useUser } from "../firebase";
import { KVIS_SIGNIN_REDIRECT } from "../firebase/UserContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useUser();
  return (
    <Route
      {...rest}
      render={
        user === null
          ? props => {
            window.sessionStorage.setItem(KVIS_SIGNIN_REDIRECT, props.location.pathname + props.location.search + props.location.hash);
            return (
              <Redirect to={{ pathname: "/login" }} />
            )
          }
          : props => {
            const redirectTo = window.sessionStorage.getItem(KVIS_SIGNIN_REDIRECT);
            window.sessionStorage.removeItem(KVIS_SIGNIN_REDIRECT);

            if (redirectTo) return (
              <Redirect to={{ pathname: redirectTo }} />
            );
            return (<Component {...props} />);
          }
      }
    />
  );
};

const LoginRoute = ({ component: Component, location, ...rest }) => {
  const { user } = useUser();
  return (
    <Route
      {...rest}
      render={
        props => {
          if (user === null) return (<Component {...props} />);

          const redirectTo = window.sessionStorage.getItem(KVIS_SIGNIN_REDIRECT);
          window.sessionStorage.removeItem(KVIS_SIGNIN_REDIRECT);

          return (<Redirect to={redirectTo || "/"} />);
        }
      }
    />
  );
};

export { PrivateRoute, LoginRoute };
